/**
 * Stable CSS class names for E2E — TestServicesUrl page.
 */
export const TSU = {
    page: 'test-services-url-page',
    environmentRow: 'test-services-url-page__environment-row',
    checkButton: 'test-services-url-input--button-check-status',
    checkButtonLabel: 'test-services-url-input--button-check-label',
    gridWrap: 'test-services-url-page__data-grid-wrap',
    cellStatusWrap: 'test-services-url__cell-status-wrap',
    cellStatusLoading: 'test-services-url__cell-status-loading',
    cellStatusOk: 'test-services-url__cell-status-ok',
    cellStatusFail: 'test-services-url__cell-status-fail',
} as const;

export const tsuCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
